import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';

export const file = createApi({
    reducerPath: 'file',
    baseQuery: createCustomFetchBaseQuery(),
    endpoints: (builder) => ({
        createFile: builder.mutation({
            query: (fileData) => {
                // Create FormData object
                console.log("fileData", fileData);

                const formData = new FormData();

                // Assuming `fileData` contains the file you want to upload
                formData.append("file", fileData); // Append the file field

                // If you want to append other form fields (like name, description, etc.), you can do so here
                // formData.append("name", "yourFileName"); // Example of adding extra fields

                return {
                    url: '/api/uploads/upload-file-only', // API endpoint for file upload
                    method: 'POST',
                    body: formData, // Send the FormData object as the body
                };
            },
        }),

        deleteFile: builder.mutation({
            query: (id) => ({
                url: `/api/uploads/delete-file-only/${id}`,
                method: 'DELETE',
            }),
        }),
    }),
});

export const {
    useCreateFileMutation,
    useDeleteFileMutation,
} = file;